// Which weekly summary a driver gets: a commission summary, a lease summary, or -- for the
// week they change over -- a combined one. Decided by the dated pay arrangements (see
// payArrangements.ts), so it follows the driver's type on each day, not just today's.

export type SummaryKind = "commission" | "lease" | "mixed";

export interface SummaryCopy {
  /** Heading on the screen dialog and email subject. */
  screenTitle: string;
  /** Heading of the Gross Turnover -> Total Payment card. */
  cardTitle: string;
  /** The line that takes the company's share off the net take. */
  shareLabel: string;
  /** The line that shows what the driver keeps of it. */
  paymentLabel: string;
  /** Bonus tiers don't apply on a lease. */
  showBonus: boolean;
}

export const SUMMARY_COPY: Record<SummaryKind, SummaryCopy> = {
  commission: {
    screenTitle: "Weekly Commission Summary",
    cardTitle: "Payment Summary",
    shareLabel: "Less Commission",
    paymentLabel: "Driver Payment",
    showBonus: true,
  },
  lease: {
    screenTitle: "Weekly Contract Payment Summary",
    cardTitle: "Contract Payment Summary",
    shareLabel: "Less Company Share (Leased %)",
    paymentLabel: "Gross Take",
    showBonus: false,
  },
  mixed: {
    screenTitle: "Weekly Commission & Lease Summary",
    cardTitle: "Commission & Lease Summary",
    shareLabel: "Less Commission & Company Share",
    paymentLabel: "Driver Payment",
    showBonus: true,
  },
};

/** One row per arrangement type in a changeover week: that part of the week's net take and what the driver keeps of it. */
export interface SummarySegment {
  label: string;
  netTake: number;
  driverShare: number;
}
